import { Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";

interface INoResultProps {
  image: ReactNode;
  text: ReactNode;
}

export const NoResult = ({ image, text }: INoResultProps) => {
  return (
    <Stack
      sx={{
        flex: "1 1 auto",
        justifyContent: "center",
        alignItems: "center",
        gap: 3,
      }}
    >
      {image}
      <Typography variant="subtitle2">{text}</Typography>
    </Stack>
  );
};

export * from "./fireworks";
export * from "./noResultEmptyImage";
export * from "./noResultToCreateImage";
